module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn-group dropdown-default btn-block pg-dropdown",
    attrs: {
      "pg-dropdown": ""
    }
  }, [_c('a', {
    staticClass: "btn btn-block dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown",
      "href": ""
    }
  }, [_vm._v("\n    " + _vm._s(_vm.selected && _vm.selected[_vm.labelProperty] ? _vm.selected[_vm.labelProperty] : 'Select') + " "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, _vm._l((_vm.items), function(item) {
    return _c('li', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.select(item)
        }
      }
    }, [_vm._v(_vm._s(item[_vm.labelProperty]))])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28252bd4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/dropdown.vue
// module id = 1231
// module chunks = 1